export const languages_2Letters = {
  km: "ខ្មែរ",
  en: "English",
};

export const rtlLanguages = [];

export const langCodeMapping = {
  khm: "km",
  eng: "en",
};

export const langFontMapping: { [key: string]: string } = {
  en: "font-inter",
  km: "font-kantumruypro",
};
